/* Cart ticket bundle A/B test — behaviour only, markup is in
   snippets/cart-ticket-bundle.liquid. Hidden until html.ctb-on, set by the
   Intelligems variant or by ?ctb=1 for QA. */
(function () {
  'use strict';

  // ajax-cart.liquid renders twice (mobile + desktop), so this loads twice.
  if (window.__ctbLoaded) return;
  window.__ctbLoaded = true;

  var PARAM = 'ctb';
  var ON_CLASS = 'ctb-on';
  var OPEN_CLASS = 'ctb-packs-open';

  // Pick these up in Intelligems once each has fired at least once.
  var GOAL_UPSELL_CLICK = 'upsell_cta_clicked';
  var GOAL_PACK_UPGRADE = 'ticket_pack_upgraded';
  var GOAL_CHECKOUT = 'checkout_clicked';
  var GOAL_DRAWER_OPEN = 'cart_drawer_opened';

  function track(name, props) {
    window.igEvents = window.igEvents || [];
    var payload = { event: name }; // Do not remove - required for tracking
    if (props) {
      Object.keys(props).forEach(function (k) {
        payload[k] = props[k];
      });
    }
    window.igEvents.push(payload);
  }

  function isOn() {
    if (document.documentElement.classList.contains(ON_CLASS)) return true;
    try {
      return new URLSearchParams(window.location.search).get(PARAM) === '1';
    } catch (e) {
      return false;
    }
  }

  function enable() {
    document.documentElement.classList.add(ON_CLASS);
  }

  /* Uses `line`, not the line item key — Shopocado rewrites its line property
     on every discount pass, so a rendered key is usually stale by click time. */
  var BUSY_CLASS = 'ctb-busy';
  var BUSY_TIMEOUT = 8000;
  var busy = false;
  var busyTimer = null;
  var settleTimer = null;

  // On #theme-ajax-cart because updateView() replaces everything inside it.
  function setBusy(state) {
    busy = state;
    Array.prototype.forEach.call(document.querySelectorAll('#theme-ajax-cart'), function (d) {
      d.classList.toggle(BUSY_CLASS, state);
    });
    if (!state) {
      window.clearTimeout(busyTimer);
      window.clearInterval(settleTimer);
    }
  }

  // Clicked block is marked stale so its optimistic highlight can't satisfy this.
  function waitForSettle(target) {
    window.clearInterval(settleTimer);
    settleTimer = window.setInterval(function () {
      var fresh = document.querySelector('.ctb--packs:not([data-ctb-stale]) .ctb__opt[aria-pressed="true"]');
      if (fresh && fresh.getAttribute('data-ctb-pack') === String(target)) setBusy(false);
    }, 100);

    window.clearTimeout(busyTimer);
    busyTimer = window.setTimeout(function () {
      setBusy(false);
    }, BUSY_TIMEOUT);
  }

  function setQuantity(target, fromPack) {
    if (busy) return;

    Array.prototype.forEach.call(document.querySelectorAll('.ctb--packs'), function (block) {
      block.setAttribute('data-ctb-stale', '');
      Array.prototype.forEach.call(block.querySelectorAll('.ctb__opt'), function (b) {
        b.setAttribute('aria-pressed', b.getAttribute('data-ctb-pack') === String(target) ? 'true' : 'false');
      });
    });
    setBusy(true);
    waitForSettle(target);

    window
      .fetch('/cart/change.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ line: 1, quantity: target })
      })
      .then(function (r) {
        if (!r.ok) throw new Error('cart change failed');
        return r.json();
      })
      .then(function (cart) {
        // Off the server's answer, not the click — Shopify clamps the line at 150.
        var landed = cart.items && cart.items[0] ? cart.items[0].quantity : 0;
        if (landed > 0 && fromPack > 0 && target > fromPack) {
          track(GOAL_PACK_UPGRADE, { from_pack: fromPack, to_pack: target, quantity: landed });
        }

        if (window.PXUTheme && window.PXUTheme.jsAjaxCart) {
          window.PXUTheme.jsAjaxCart.updateView();
        }
      })
      .catch(function () {
        if (window.PXUTheme && window.PXUTheme.jsAjaxCart) {
          window.PXUTheme.jsAjaxCart.updateView();
        }
        setBusy(false);
      });
  }

  function onClick(e) {
    var el = e.target.closest ? e.target.closest('[data-ctb-pack], [data-ctb-toggle], [name="checkout"]') : null;
    if (!el) return;

    if (el.hasAttribute('data-ctb-toggle')) {
      e.preventDefault();
      // On #theme-ajax-cart so the panel survives a cart change.
      var open = !document.querySelector('.' + OPEN_CLASS);
      Array.prototype.forEach.call(document.querySelectorAll('#theme-ajax-cart'), function (d) {
        d.classList.toggle(OPEN_CLASS, open);
      });
      Array.prototype.forEach.call(document.querySelectorAll('[data-ctb-toggle]'), function (t) {
        t.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
      return;
    }

    if (el.getAttribute('name') === 'checkout') {
      // Fires in control too — the checkout button is untouched by this test.
      if (!el.disabled) track(GOAL_CHECKOUT);
      return;
    }

    e.preventDefault();
    var target = parseInt(el.getAttribute('data-ctb-pack'), 10);
    var fromPack = parseInt(el.getAttribute('data-ctb-from'), 10) || 0;
    if (!target || el.getAttribute('aria-pressed') === 'true') return;

    if (el.hasAttribute('data-ctb-nudge')) {
      track(GOAL_UPSELL_CLICK, { from_pack: fromPack, to_pack: target });
    }

    setQuantity(target, fromPack);
  }

  /* Denominator of shoppers actually exposed — Intelligems buckets everyone on
     page load, and most never open the cart. */
  function watchDrawer() {
    var drawers = document.querySelectorAll('#theme-ajax-cart');
    if (!drawers.length) return false;

    var wasOpen = false;

    var observer = new MutationObserver(function () {
      var open = !!document.querySelector('#theme-ajax-cart.is-visible');
      if (open === wasOpen) return;
      wasOpen = open;

      if (open && document.querySelector('.ajax-cart__product')) {
        track(GOAL_DRAWER_OPEN);
      }
    });

    Array.prototype.forEach.call(drawers, function (d) {
      observer.observe(d, { attributes: true, attributeFilter: ['class'] });
    });
    return true;
  }

  function init() {
    if (isOn()) enable();

    document.addEventListener('click', onClick, true);

    // Drawer markup is fetched async, so it may not exist yet.
    if (!watchDrawer()) {
      var retry = new MutationObserver(function () {
        if (watchDrawer()) retry.disconnect();
      });
      retry.observe(document.documentElement, { childList: true, subtree: true });
      window.setTimeout(function () {
        retry.disconnect();
      }, 10000);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
